import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../../components/feature/Sidebar';
import Card from '../../components/base/Card';
import Button from '../../components/base/Button';
import { mockProjects } from '../../mocks/projects';

export default function ConfigPage() {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [projects] = useState(mockProjects);
  const [openDropdown, setOpenDropdown] = useState<string | null>(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [statusFilter, setStatusFilter] = useState<'all' | 'active' | 'completed'>('all');
  const [keywordInput, setKeywordInput] = useState('');
  const [editingKeywordIndex, setEditingKeywordIndex] = useState<number | null>(null);
  
  const platforms = ['小红书', '微博', '抖音', '视频号'];
  
  const [formData, setFormData] = useState({
    name: '',
    keywords: [] as string[],
    startDate: new Date().toISOString().split('T')[0],
    endDate: '',
    platforms: platforms,
  });
  
  // 过滤项目
  const filteredProjects = projects.filter(project => {
    const matchesSearch = project.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
                         project.keywords.some(k => k.toLowerCase().includes(searchQuery.toLowerCase()));
    const matchesStatus = statusFilter === 'all' || project.status === statusFilter;
    return matchesSearch && matchesStatus;
  });
  
  const handlePlatformToggle = (platform: string) => {
    setFormData(prev => ({
      ...prev,
      platforms: prev.platforms.includes(platform)
        ? prev.platforms.filter(p => p !== platform)
        : [...prev.platforms, platform]
    }));
  };

  const handleAddKeyword = () => {
    const trimmedKeyword = keywordInput.trim();
    if (trimmedKeyword && !formData.keywords.includes(trimmedKeyword)) {
      if (editingKeywordIndex !== null) {
        // 编辑模式
        const newKeywords = [...formData.keywords];
        newKeywords[editingKeywordIndex] = trimmedKeyword;
        setFormData(prev => ({ ...prev, keywords: newKeywords }));
        setEditingKeywordIndex(null);
      } else {
        // 添加模式
        setFormData(prev => ({ ...prev, keywords: [...prev.keywords, trimmedKeyword] }));
      }
      setKeywordInput('');
    }
  };

  const handleEditKeyword = (index: number) => {
    setKeywordInput(formData.keywords[index]);
    setEditingKeywordIndex(index);
  };

  const handleDeleteKeyword = (index: number) => {
    setFormData(prev => ({
      ...prev,
      keywords: prev.keywords.filter((_, i) => i !== index)
    }));
    if (editingKeywordIndex === index) {
      setKeywordInput('');
      setEditingKeywordIndex(null);
    }
  };

  const handleKeywordInputKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleAddKeyword();
    } else if (e.key === 'Escape' && editingKeywordIndex !== null) {
      setKeywordInput('');
      setEditingKeywordIndex(null);
    }
  };
  
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (formData.keywords.length === 0) {
      alert('请至少添加一个监测关键词');
      return;
    }
    setShowModal(false);
    setFormData({
      name: '',
      keywords: [],
      startDate: '',
      endDate: '',
      platforms: [],
    });
    setKeywordInput('');
    setEditingKeywordIndex(null);
  };

  const handleEdit = (projectId: string) => {
    setOpenDropdown(null);
    // 编辑逻辑
    console.log('编辑项目:', projectId);
  };

  const handleToggleStatus = (projectId: string, currentStatus: string) => {
    setOpenDropdown(null);
    // 切换监测状态逻辑
    console.log('切换状态:', projectId, currentStatus);
  };

  const handleDelete = (projectId: string) => {
    setOpenDropdown(null);
    if (confirm('确定要删除这个项目吗？')) {
      // 删除逻辑
      console.log('删除项目:', projectId);
    }
  };
  
  return (
    <div className="flex min-h-screen bg-gray-50">
      <Sidebar />
      
      <main className="flex-1 ml-64">
        <div className="p-8">
          <div className="flex items-center justify-between mb-8">
            <div>
              <h1 className="text-2xl font-bold text-gray-900">项目配置</h1>
              <p className="text-sm text-gray-500 mt-1">创建和管理舆情监测项目</p>
            </div>
            <Button onClick={() => setShowModal(true)}>
              <i className="ri-add-line mr-2"></i>
              新建项目
            </Button>
          </div>
          
          <div className="mb-6 flex items-center gap-4">
            <div className="flex-1 relative">
              <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 text-lg"></i>
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="搜索项目名称或关键词..."
                className="w-full pl-12 pr-4 py-3 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-[#4A8AE9] focus:border-transparent"
              />
            </div>
            
            <div className="flex items-center gap-2 bg-white border border-gray-300 rounded-lg p-1">
              <button
                onClick={() => setStatusFilter('all')}
                className={`px-4 py-2 rounded-md text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                  statusFilter === 'all'
                    ? 'bg-[#4A8AE9] text-white'
                    : 'text-gray-700 hover:bg-gray-100'
                }`}
              >
                全部
              </button>
              <button
                onClick={() => setStatusFilter('active')}
                className={`px-4 py-2 rounded-md text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                  statusFilter === 'active'
                    ? 'bg-[#4A8AE9] text-white'
                    : 'text-gray-700 hover:bg-gray-100'
                }`}
              >
                监测中
              </button>
              <button
                onClick={() => setStatusFilter('completed')}
                className={`px-4 py-2 rounded-md text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                  statusFilter === 'completed'
                    ? 'bg-[#4A8AE9] text-white'
                    : 'text-gray-700 hover:bg-gray-100'
                }`}
              >
                已完成
              </button>
            </div>
          </div>
          
          {filteredProjects.length === 0 ? (
            <div className="text-center py-16">
              <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-search-line text-gray-400 text-4xl"></i>
              </div>
              <h3 className="text-lg font-medium text-gray-900 mb-2">未找到相关项目</h3>
              <p className="text-sm text-gray-500">尝试调整搜索条件或筛选状态</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6">
              {filteredProjects.map((project) => (
                <Card key={project.id}>
                  <div className="flex items-start justify-between mb-4">
                    <div className="flex-1">
                      <h3 className="text-lg font-semibold text-gray-900 mb-1">{project.name}</h3>
                      <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${
                        project.status === 'active' 
                          ? 'bg-green-100 text-green-800' 
                          : 'bg-gray-100 text-gray-800'
                      }`}>
                        {project.status === 'active' ? '监测中' : '已完成'}
                      </span>
                    </div>
                    <div className="relative">
                      <button 
                        onClick={() => setOpenDropdown(openDropdown === project.id ? null : project.id)}
                        className="text-gray-400 hover:text-gray-600 cursor-pointer"
                      >
                        <i className="ri-more-2-fill text-xl"></i>
                      </button>
                      {openDropdown === project.id && (
                        <>
                          <div 
                            className="fixed inset-0 z-10" 
                            onClick={() => setOpenDropdown(null)}
                          ></div>
                          <div className="absolute right-0 top-8 w-40 bg-white rounded-lg shadow-lg border border-gray-200 py-1 z-20">
                            <button
                              onClick={() => handleEdit(project.id)}
                              className="w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-50 flex items-center gap-2 cursor-pointer whitespace-nowrap"
                            >
                              <i className="ri-edit-line w-4 h-4 flex items-center justify-center"></i>
                              编辑
                            </button>
                            <button
                              onClick={() => handleToggleStatus(project.id, project.status)}
                              className="w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-50 flex items-center gap-2 cursor-pointer whitespace-nowrap"
                            >
                              <i className={`${project.status === 'active' ? 'ri-pause-line' : 'ri-play-line'} w-4 h-4 flex items-center justify-center`}></i>
                              {project.status === 'active' ? '停止监测' : '开始监测'}
                            </button>
                            <div className="border-t border-gray-100 my-1"></div>
                            <button
                              onClick={() => handleDelete(project.id)}
                              className="w-full px-4 py-2 text-left text-sm text-red-600 hover:bg-red-50 flex items-center gap-2 cursor-pointer whitespace-nowrap"
                            >
                              <i className="ri-delete-bin-line w-4 h-4 flex items-center justify-center"></i>
                              删除
                            </button>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                  
                  <div className="space-y-3 mb-4">
                    <div className="flex items-center text-sm text-gray-600">
                      <i className="ri-calendar-line mr-2 w-4 h-4 flex items-center justify-center"></i>
                      <span>{project.startDate} 至 {project.endDate}</span>
                    </div>
                    
                    <div className="flex items-start text-sm text-gray-600">
                      <i className="ri-key-2-line mr-2 mt-0.5 w-4 h-4 flex items-center justify-center"></i>
                      <div className="flex flex-wrap gap-1">
                        {project.keywords.map((keyword, idx) => (
                          <span key={idx} className="bg-gray-100 px-2 py-0.5 rounded text-xs whitespace-nowrap">
                            {keyword}
                          </span>
                        ))}
                      </div>
                    </div>
                    
                    <div className="flex items-center text-sm text-gray-600">
                      <i className="ri-apps-line mr-2 w-4 h-4 flex items-center justify-center"></i>
                      <span>{project.platforms.join('、')}</span>
                    </div>
                  </div>
                  
                  <div className="flex gap-2 pt-4 border-t border-gray-100">
                    <Button variant="primary" size="md" className="flex-1" onClick={() => navigate('/analysis')}>
                      <i className="ri-eye-line mr-2"></i>
                      查看分析
                    </Button>
                  </div>
                </Card>
              ))}
            </div>
          )}
        </div>
      </main>
      
      {showModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg w-full max-w-2xl max-h-[90vh] overflow-y-auto">
            <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between">
              <h2 className="text-xl font-semibold text-gray-900">新建监测项目</h2>
              <button 
                onClick={() => setShowModal(false)}
                className="text-gray-400 hover:text-gray-600 cursor-pointer"
              >
                <i className="ri-close-line text-2xl"></i>
              </button>
            </div>
            
            <form onSubmit={handleSubmit} className="p-6 space-y-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  展览名称 <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  required
                  value={formData.name}
                  onChange={(e) => setFormData(prev => ({ ...prev, name: e.target.value }))}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-[#4A8AE9] focus:border-transparent"
                  placeholder="请输入展览名称"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  监测关键词 <span className="text-red-500">*</span>
                </label>
                <div className="space-y-3">
                  <div className="flex gap-2">
                    <input
                      type="text"
                      value={keywordInput}
                      onChange={(e) => setKeywordInput(e.target.value)}
                      onKeyDown={handleKeywordInputKeyDown}
                      className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-[#4A8AE9] focus:border-transparent"
                      placeholder={editingKeywordIndex !== null ? "编辑关键词" : "输入关键词后点击添加"}
                    />
                    <button
                      type="button"
                      onClick={handleAddKeyword}
                      className="px-4 py-2 bg-[#4A8AE9] text-white rounded-lg text-sm font-medium hover:bg-[#3A7AD9] transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1"
                    >
                      <i className={`${editingKeywordIndex !== null ? 'ri-check-line' : 'ri-add-line'} w-4 h-4 flex items-center justify-center`}></i>
                      {editingKeywordIndex !== null ? '确认' : '添加'}
                    </button>
                    {editingKeywordIndex !== null && (
                      <button
                        type="button"
                        onClick={() => {
                          setKeywordInput('');
                          setEditingKeywordIndex(null);
                        }}
                        className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg text-sm font-medium hover:bg-gray-300 transition-colors cursor-pointer whitespace-nowrap"
                      >
                        取消
                      </button>
                    )}
                  </div>
                  
                  {formData.keywords.length > 0 && (
                    <div className="flex flex-wrap gap-2 p-3 bg-gray-50 rounded-lg border border-gray-200">
                      {formData.keywords.map((keyword, index) => (
                        <div
                          key={index}
                          className={`flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition-colors ${
                            editingKeywordIndex === index
                              ? 'bg-[#4A8AE9] text-white'
                              : 'bg-white text-gray-700 border border-gray-300'
                          }`}
                        >
                          <span>{keyword}</span>
                          <div className="flex items-center gap-1">
                            <button
                              type="button"
                              onClick={() => handleEditKeyword(index)}
                              className="w-5 h-5 flex items-center justify-center hover:bg-black/10 rounded cursor-pointer transition-colors"
                              title="编辑"
                            >
                              <i className="ri-edit-line text-xs"></i>
                            </button>
                            <button
                              type="button"
                              onClick={() => handleDeleteKeyword(index)}
                              className="w-5 h-5 flex items-center justify-center hover:bg-black/10 rounded cursor-pointer transition-colors"
                              title="删除"
                            >
                              <i className="ri-close-line text-sm"></i>
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                  
                  {formData.keywords.length === 0 && (
                    <p className="text-xs text-gray-500">请至少添加一个监测关键词</p>
                  )}
                </div>
              </div>
              
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    开始日期 <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="date"
                    required
                    value={formData.startDate}
                    onChange={(e) => setFormData(prev => ({ ...prev, startDate: e.target.value }))}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-[#4A8AE9] focus:border-transparent"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    结束日期 <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="date"
                    required
                    value={formData.endDate}
                    onChange={(e) => setFormData(prev => ({ ...prev, endDate: e.target.value }))}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-[#4A8AE9] focus:border-transparent"
                  />
                </div>
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-3">
                  监测平台 <span className="text-red-500">*</span>
                </label>
                <div className="flex items-center gap-3">
                  {platforms.map((platform) => (
                    <label
                      key={platform}
                      className={`flex-1 flex items-center justify-center gap-2 p-4 border-2 rounded-lg cursor-pointer transition-all ${
                        formData.platforms.includes(platform)
                          ? 'border-[#4A8AE9] bg-[#4A8AE9]/5'
                          : 'border-gray-200 hover:border-[#4A8AE9]/50'
                      }`}
                    >
                      <input
                        type="checkbox"
                        checked={formData.platforms.includes(platform)}
                        onChange={() => handlePlatformToggle(platform)}
                        className="w-4 h-4 text-[#4A8AE9] border-gray-300 rounded focus:ring-[#4A8AE9] cursor-pointer"
                      />
                      <i className={`${
                        platform === '小红书' ? 'ri-book-mark-line' :
                        platform === '微博' ? 'ri-weibo-line' :
                        platform === '抖音' ? 'ri-music-line' :
                        'ri-video-line'
                      } text-base`}></i>
                      <span className="text-sm font-medium text-gray-700">{platform}</span>
                    </label>
                  ))}
                </div>
              </div>
              
              <div className="flex gap-3 pt-4">
                <Button type="button" variant="secondary" className="flex-1" onClick={() => setShowModal(false)}>
                  取消
                </Button>
                <Button type="submit" className="flex-1">
                  创建项目
                </Button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
